import { IconButton, IconName, Tooltip } from "@narmi/design_system";
import React from "react";
import styles from "./rightToolbar.module.css";

function RightToolbarLayout({ children }: { children: React.ReactNode }) {
  return <div className={styles.toolbarContainer}>{children}</div>;
}

function Toolbar({ children }: { children: React.ReactNode }) {
  return <div className={styles.verticalToolbar}>{children}</div>;
}

function ToolbarButton({
  label,
  iconName,
  onClick,
}: {
  label: string;
  iconName: IconName;
  onClick: () => void;
}) {
  return (
    <Tooltip side="left" text={label}>
      <IconButton name={iconName} kind="action" onClick={onClick} />
    </Tooltip>
  );
}

RightToolbarLayout.Toolbar = Toolbar;
RightToolbarLayout.ToolbarButton = ToolbarButton;

export { RightToolbarLayout };
